import _slicedToArray from "C:\\vsts-agent\\_work\\2\\s\\ops-web\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { notification } from "antd";
import { useFetch } from "../http/fetch-context";
export var Status;

(function (Status) {
  Status["checking"] = "cheking";
  Status["loggedIn"] = "loggedIn";
  Status["loggedOut"] = "loggedOut";
})(Status || (Status = {}));

var AuthenticationContext = React.createContext(undefined);
export function useAuthentication() {
  var ctx = React.useContext(AuthenticationContext);

  if (ctx === null || ctx === undefined) {
    throw new Error("Cannot use authentication outside of AuthenticationProvider");
  }

  return ctx;
}
export function AuthenticationProvider(props) {
  var _React$useState = React.useState(Status.checking),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      status = _React$useState2[0],
      setStatus = _React$useState2[1];

  var fetch = useFetch();

  var _React$useState3 = React.useState({
    claims: [],
    displayName: null,
    email: null,
    userId: null,
    identityName: null,
    isAuthenticated: false,
    objectId: null,
    scopes: []
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      profile = _React$useState4[0],
      setProfile = _React$useState4[1];

  React.useEffect(function () {
    setStatus(Status.checking);
    fetch("/glow/profile", {
      credentials: "same-origin"
    }).then(function (v) {
      if (v.ok) {
        return v.json();
      } else {
        throw new Error("" + v.statusText + v.status);
      }
    }).then(function (data) {
      setStatus(data.isAuthenticated ? Status.loggedIn : Status.loggedOut);
      setProfile(data);
    }).catch(function (e) {
      notification.error({
        message: "Could not check for profile information: " + e.toString()
      });
      setStatus(Status.loggedOut);
    });
  }, []);
  var value = React.useMemo(function () {
    return {
      login: function login(req) {
        window.location.replace("/Account/SignIn?redirectUrl=".concat(window.location.pathname));
      },
      status: status,
      profile: profile,
      userIsAuthenticated: status === "loggedIn"
    };
  }, [status, profile]);
  return React.createElement(AuthenticationContext.Provider, {
    value: value
  }, props.children);
}